// eslint-disable-next-line jira/filename-case
import React, { type ComponentPropsWithoutRef } from 'react';
import { Router as ResourceRouter } from '@atlassian/react-resource-router';
import type {
	ResourceStoreContext,
	ResourceStoreData,
} from '@atlassian/react-resource-router/src/resources';
import { usePlugins } from '../../controller/usePlugins.tsx';

export type RouterProps = Omit<ComponentPropsWithoutRef<typeof ResourceRouter>, 'plugins'> & {
	resourceContext?: ResourceStoreContext | undefined;
	resourceData?: ResourceStoreData | undefined;
};

export const Router = ({ children, ...props }: RouterProps): React.JSX.Element => {
	const pluginsWithOverride = usePlugins({
		resourceContext: props.resourceContext,
		resourceData: props.resourceData,
	});

	return (
		<ResourceRouter plugins={pluginsWithOverride} {...props}>
			{children}
		</ResourceRouter>
	);
};
